import { c as _c } from "react/compiler-runtime";
import AutoAwesomeMotion from "@mui/icons-material/AutoAwesomeMotion";
import CallSplit from "@mui/icons-material/CallSplit";
import History from "@mui/icons-material/History";
import PlayCircleOutline from "@mui/icons-material/PlayCircleOutline";
import { alpha, Box, Button, Card, CardActionArea, Chip, Container, Grid, Stack, Typography, useTheme } from "@mui/material";
import Link from "next/link";
import React from "react";
import { LANDING_PLAYGROUND_DEMOS } from "#/features/homePage/lib/landingPlaygroundDemos";
import type { TranslationFunctions } from "#/i18n/i18n-types";
export type HomeLandingSectionsProps = {
  LL: TranslationFunctions;
};
type LandingDemoId = (typeof LANDING_PLAYGROUND_DEMOS)[number]["id"];
function landingDemoLabel(LL: TranslationFunctions, id: LandingDemoId): string {
  switch (id) {
    case "tree":
      return LL.HOME_DEMO_TREE();
    case "graph":
      return LL.HOME_DEMO_GRAPH();
    case "grid":
      return LL.HOME_DEMO_GRID();
    case "trie":
      return LL.HOME_DEMO_TRIE();
    default:
      {
        const _exhaustive: never = id;
        return _exhaustive;
      }
  }
}
function landingDemoSlug(href: string): string {
  return href.replace("/playground/", "").replace("?view=code", "").split("-").join(" ");
}
export const HomeLandingSections: React.FC<HomeLandingSectionsProps> = t0 => {
  const $ = _c(159);
  const {
    LL
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CallSplit fontSize="small" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== LL) {
    t2 = LL.HOME_PILLAR_VIS_TITLE();
    $[1] = LL;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== LL) {
    t3 = LL.HOME_PILLAR_VIS_BODY();
    $[3] = LL;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = {
      icon: t1,
      title: t2,
      body: t3
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PlayCircleOutline fontSize="small" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== LL) {
    t6 = LL.HOME_PILLAR_WORKERS_TITLE();
    $[9] = LL;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== LL) {
    t7 = LL.HOME_PILLAR_WORKERS_BODY();
    $[11] = LL;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = {
      icon: t5,
      title: t6,
      body: t7
    };
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <History fontSize="small" />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== LL) {
    t10 = LL.HOME_PILLAR_REPLAY_TITLE();
    $[17] = LL;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== LL) {
    t11 = LL.HOME_PILLAR_REPLAY_BODY();
    $[19] = LL;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = {
      icon: t9,
      title: t10,
      body: t11
    };
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <AutoAwesomeMotion fontSize="small" />;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== LL) {
    t14 = LL.HOME_PILLAR_BENCH_TITLE();
    $[25] = LL;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== LL) {
    t15 = LL.HOME_PILLAR_BENCH_BODY();
    $[27] = LL;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t14 || $[30] !== t15) {
    t16 = {
      icon: t13,
      title: t14,
      body: t15
    };
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t12 || $[33] !== t16 || $[34] !== t4 || $[35] !== t8) {
    t17 = [t4, t8, t12, t16];
    $[32] = t12;
    $[33] = t16;
    $[34] = t4;
    $[35] = t8;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  const capabilities = t17 as const;
  let t18;
  if ($[37] !== LL) {
    t18 = LL.RUN();
    $[37] = LL;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== LL) {
    t19 = LL.HOME_HOW_STEP_2_BODY();
    $[39] = LL;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t18 || $[42] !== t19) {
    t20 = {
      label: t18,
      body: t19
    };
    $[41] = t18;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== LL) {
    t21 = LL.FORWARD();
    $[44] = LL;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== LL) {
    t22 = LL.HOME_HOW_STEP_3_BODY();
    $[46] = LL;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t21 || $[49] !== t22) {
    t23 = {
      label: t21,
      body: t22
    };
    $[48] = t21;
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== LL) {
    t24 = LL.REPLAY();
    $[51] = LL;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== LL) {
    t25 = LL.HOME_PILLAR_REPLAY_BODY();
    $[53] = LL;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t24 || $[56] !== t25) {
    t26 = {
      label: t24,
      body: t25
    };
    $[55] = t24;
    $[56] = t25;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== LL) {
    t27 = LL.CALLSTACK();
    $[58] = LL;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] !== LL) {
    t28 = LL.HOME_PILLAR_VIS_BODY();
    $[60] = LL;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== t27 || $[63] !== t28) {
    t29 = {
      label: t27,
      body: t28
    };
    $[62] = t27;
    $[63] = t28;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  let t30;
  if ($[65] !== t20 || $[66] !== t23 || $[67] !== t26 || $[68] !== t29) {
    t30 = [t20, t23, t26, t29];
    $[65] = t20;
    $[66] = t23;
    $[67] = t26;
    $[68] = t29;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  const coreLoop = t30 as const;
  let t31;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = {
      py: {
        xs: 6,
        md: 8
      },
      bgcolor: "background.default"
    };
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  let t32;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      px: {
        xs: 2,
        sm: 3,
        md: 4
      }
    };
    $[71] = t32;
  } else {
    t32 = $[71];
  }
  let t33;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = {
      mb: 1.5,
      maxWidth: 780
    };
    $[72] = t33;
  } else {
    t33 = $[72];
  }
  let t34;
  if ($[73] !== LL) {
    t34 = LL.HOME_PILLAR_VIS_TITLE();
    $[73] = LL;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  let t35;
  if ($[75] !== t34) {
    t35 = <Typography id="landing-capabilities-heading" variant="h3" component="h2" sx={t33}>{t34}</Typography>;
    $[75] = t34;
    $[76] = t35;
  } else {
    t35 = $[76];
  }
  let t36;
  if ($[77] !== capabilities || $[78] !== theme.appDesign.outline || $[79] !== theme.appDesign.surface) {
    t36 = <Grid container={true} spacing={3}>{capabilities.map(capability => <Grid key={capability.title} size={{
        xs: 12,
        sm: 6,
        lg: 3
      }}><Card sx={{
          height: "100%",
          borderColor: alpha(theme.appDesign.outline, 0.12),
          bgcolor: alpha(theme.appDesign.surface, 0.92)
        }}><Stack spacing={1.5} sx={{
            p: 2.5
          }}><Chip size="small" icon={capability.icon} label={capability.title} sx={{
              alignSelf: "flex-start"
            }} /><Typography variant="body2" color="text.secondary" sx={{
              lineHeight: 1.75
            }}>{capability.body}</Typography></Stack></Card></Grid>)}</Grid>;
    $[77] = capabilities;
    $[78] = theme.appDesign.outline;
    $[79] = theme.appDesign.surface;
    $[80] = t36;
  } else {
    t36 = $[80];
  }
  let t37;
  if ($[81] !== t35 || $[82] !== t36) {
    t37 = <Box sx={t31}><Container maxWidth="xl" sx={t32}>{t35}{t36}</Container></Box>;
    $[81] = t35;
    $[82] = t36;
    $[83] = t37;
  } else {
    t37 = $[83];
  }
  let t38;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = {
      xs: 6,
      md: 8
    };
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  let t39;
  if ($[85] !== theme.appDesign.surfaceLow) {
    t39 = alpha(theme.appDesign.surfaceLow, 0.65);
    $[85] = theme.appDesign.surfaceLow;
    $[86] = t39;
  } else {
    t39 = $[86];
  }
  let t40;
  if ($[87] !== t39) {
    t40 = {
      py: t38,
      bgcolor: t39
    };
    $[87] = t39;
    $[88] = t40;
  } else {
    t40 = $[88];
  }
  let t41;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = {
      px: {
        xs: 2,
        sm: 3,
        md: 4
      }
    };
    $[89] = t41;
  } else {
    t41 = $[89];
  }
  let t42;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = {
      mb: 1.5,
      maxWidth: 720
    };
    $[90] = t42;
  } else {
    t42 = $[90];
  }
  let t43;
  if ($[91] !== LL) {
    t43 = LL.HOME_SECTION_HOW_IT_WORKS();
    $[91] = LL;
    $[92] = t43;
  } else {
    t43 = $[92];
  }
  let t44;
  if ($[93] !== t43) {
    t44 = <Typography variant="h3" component="h2" sx={t42}>{t43}</Typography>;
    $[93] = t43;
    $[94] = t44;
  } else {
    t44 = $[94];
  }
  let t45;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = {
      mb: 4,
      maxWidth: 680
    };
    $[95] = t45;
  } else {
    t45 = $[95];
  }
  let t46;
  if ($[96] !== LL) {
    t46 = LL.HOME_HOW_STEP_1_BODY();
    $[96] = LL;
    $[97] = t46;
  } else {
    t46 = $[97];
  }
  let t47;
  if ($[98] !== t46) {
    t47 = <Typography variant="body1" color="text.secondary" sx={t45}>{t46}</Typography>;
    $[98] = t46;
    $[99] = t47;
  } else {
    t47 = $[99];
  }
  let t48;
  if ($[100] !== coreLoop || $[101] !== theme.appDesign.outline || $[102] !== theme.appDesign.surfaceLowest) {
    t48 = <Grid container={true} spacing={2}>{coreLoop.map((item, index) => <Grid key={item.label} size={{
        xs: 12,
        sm: 6,
        lg: 3
      }}><Card sx={{
          height: "100%",
          bgcolor: alpha(theme.appDesign.surfaceLowest, 0.86),
          borderColor: alpha(theme.appDesign.outline, 0.1)
        }}><Stack spacing={2} sx={{
            p: 2.5
          }}><Typography variant="overline" color="text.secondary">{String(index + 1).padStart(2, "0")}</Typography><Typography variant="h6">{item.label}</Typography><Typography variant="body2" color="text.secondary" sx={{
              lineHeight: 1.75
            }}>{item.body}</Typography></Stack></Card></Grid>)}</Grid>;
    $[100] = coreLoop;
    $[101] = theme.appDesign.outline;
    $[102] = theme.appDesign.surfaceLowest;
    $[103] = t48;
  } else {
    t48 = $[103];
  }
  let t49;
  if ($[104] !== t44 || $[105] !== t47 || $[106] !== t48) {
    t49 = <Container maxWidth="xl" sx={t41}>{t44}{t47}{t48}</Container>;
    $[104] = t44;
    $[105] = t47;
    $[106] = t48;
    $[107] = t49;
  } else {
    t49 = $[107];
  }
  let t50;
  if ($[108] !== t40 || $[109] !== t49) {
    t50 = <Box sx={t40}>{t49}</Box>;
    $[108] = t40;
    $[109] = t49;
    $[110] = t50;
  } else {
    t50 = $[110];
  }
  let t51;
  if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = {
      xs: 6,
      md: 8
    };
    $[111] = t51;
  } else {
    t51 = $[111];
  }
  let t52;
  if ($[112] !== theme.appDesign.surfaceLow) {
    t52 = alpha(theme.appDesign.surfaceLow, 0.65);
    $[112] = theme.appDesign.surfaceLow;
    $[113] = t52;
  } else {
    t52 = $[113];
  }
  let t53;
  if ($[114] !== t52) {
    t53 = {
      py: t51,
      bgcolor: t52
    };
    $[114] = t52;
    $[115] = t53;
  } else {
    t53 = $[115];
  }
  let t54;
  if ($[116] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = {
      px: {
        xs: 2,
        sm: 3,
        md: 4
      }
    };
    $[116] = t54;
  } else {
    t54 = $[116];
  }
  let t55;
  if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = {
      color: "text.secondary",
      mb: 1.5
    };
    $[117] = t55;
  } else {
    t55 = $[117];
  }
  let t56;
  if ($[118] !== LL) {
    t56 = LL.HOME_SECTION_TRY_DEMOS();
    $[118] = LL;
    $[119] = t56;
  } else {
    t56 = $[119];
  }
  let t57;
  if ($[120] !== t56) {
    t57 = <Typography variant="subtitle2" component="h2" sx={t55}>{t56}</Typography>;
    $[120] = t56;
    $[121] = t57;
  } else {
    t57 = $[121];
  }
  let t58;
  if ($[122] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = {
      mb: 1.5,
      maxWidth: 720
    };
    $[122] = t58;
  } else {
    t58 = $[122];
  }
  let t59;
  if ($[123] !== LL) {
    t59 = LL.BROWSE_PROJECTS();
    $[123] = LL;
    $[124] = t59;
  } else {
    t59 = $[124];
  }
  let t60;
  if ($[125] !== t59) {
    t60 = <Typography variant="h3" component="h2" sx={t58}>{t59}</Typography>;
    $[125] = t59;
    $[126] = t60;
  } else {
    t60 = $[126];
  }
  let t61;
  if ($[127] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = {
      mb: 4,
      maxWidth: 620
    };
    $[127] = t61;
  } else {
    t61 = $[127];
  }
  let t62;
  if ($[128] !== LL) {
    t62 = LL.HOME_TRY_DEMOS_LEAD();
    $[128] = LL;
    $[129] = t62;
  } else {
    t62 = $[129];
  }
  let t63;
  if ($[130] !== t62) {
    t63 = <Typography variant="body1" color="text.secondary" sx={t61}>{t62}</Typography>;
    $[130] = t62;
    $[131] = t63;
  } else {
    t63 = $[131];
  }
  let t64;
  if ($[132] !== LL || $[133] !== theme.appDesign.accent || $[134] !== theme.appDesign.accentSoft || $[135] !== theme.appDesign.outline || $[136] !== theme.appDesign.surface) {
    t64 = LANDING_PLAYGROUND_DEMOS.map(t65 => {
      const {
        href,
        id,
        Icon
      } = t65;
      return <Grid key={href} size={{
        xs: 12,
        sm: 6,
        lg: 3
      }}><Card sx={{
          height: "100%",
          borderColor: alpha(theme.appDesign.outline, 0.12),
          bgcolor: alpha(theme.appDesign.surface, 0.92),
          transition: "transform 0.2s ease, border-color 0.2s ease",
          "&:hover": {
            transform: "translateY(-3px)",
            borderColor: alpha(theme.appDesign.accentSoft, 0.28)
          }
        }}><CardActionArea component={Link} href={href} sx={{
            p: 2.5
          }}><Stack spacing={2}><Box sx={{
                width: 48,
                height: 48,
                borderRadius: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: alpha(theme.appDesign.accent, 0.12),
                color: theme.appDesign.accentSoft
              }}><Icon /></Box><Stack spacing={0.5}><Typography variant="subtitle2" color="text.secondary">{LL.HOME_SECTION_TRY_DEMOS()}</Typography><Typography variant="h6">{landingDemoLabel(LL, id)}</Typography></Stack><Typography variant="body2" color="text.secondary">{landingDemoSlug(href)}</Typography></Stack></CardActionArea></Card></Grid>;
    });
    $[132] = LL;
    $[133] = theme.appDesign.accent;
    $[134] = theme.appDesign.accentSoft;
    $[135] = theme.appDesign.outline;
    $[136] = theme.appDesign.surface;
    $[137] = t64;
  } else {
    t64 = $[137];
  }
  let t65;
  if ($[138] !== t64) {
    t65 = <Grid container={true} spacing={2.5}>{t64}</Grid>;
    $[138] = t64;
    $[139] = t65;
  } else {
    t65 = $[139];
  }
  let t66;
  if ($[140] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = {
      mt: 3,
      textAlign: {
        xs: "center",
        sm: "left"
      }
    };
    $[140] = t66;
  } else {
    t66 = $[140];
  }
  let t67;
  if ($[141] === Symbol.for("react.memo_cache_sentinel")) {
    t67 = {
      px: 3
    };
    $[141] = t67;
  } else {
    t67 = $[141];
  }
  let t68;
  if ($[142] !== LL) {
    t68 = LL.BROWSE_PROJECTS();
    $[142] = LL;
    $[143] = t68;
  } else {
    t68 = $[143];
  }
  let t69;
  if ($[144] !== t68) {
    t69 = <Box sx={t66}><Button component={Link} href="/playground?view=browse" variant="contained" size="large" sx={t67}>{t68}</Button></Box>;
    $[144] = t68;
    $[145] = t69;
  } else {
    t69 = $[145];
  }
  let t70;
  if ($[146] !== t57 || $[147] !== t60 || $[148] !== t63 || $[149] !== t65 || $[150] !== t69) {
    t70 = <Container maxWidth="xl" sx={t54}>{t57}{t60}{t63}{t65}{t69}</Container>;
    $[146] = t57;
    $[147] = t60;
    $[148] = t63;
    $[149] = t65;
    $[150] = t69;
    $[151] = t70;
  } else {
    t70 = $[151];
  }
  let t71;
  if ($[152] !== t53 || $[153] !== t70) {
    t71 = <Box sx={t53}>{t70}</Box>;
    $[152] = t53;
    $[153] = t70;
    $[154] = t71;
  } else {
    t71 = $[154];
  }
  let t72;
  if ($[155] !== t37 || $[156] !== t50 || $[157] !== t71) {
    t72 = <Box component="section" aria-labelledby="landing-capabilities-heading">{t37}{t50}{t71}</Box>;
    $[155] = t37;
    $[156] = t50;
    $[157] = t71;
    $[158] = t72;
  } else {
    t72 = $[158];
  }
  return t72;
};